import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = {
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.currentIndex = 0
    this.loadDeferredSlides()
    this.startAutoSlide()
  }

  disconnect() {
    this.stopAutoSlide()
  }

  // 1枚目(LCP画像)の読み込みと帯域を奪い合わないよう、2枚目以降はpage load後にsrcを差し込む
  loadDeferredSlides() {
    const assign = () => {
      this.slideTargets.forEach((slide) => {
        if (slide.dataset.src && !slide.src) {
          slide.src = slide.dataset.src
        }
      })
    }

    if (document.readyState === "complete") {
      assign()
    } else {
      window.addEventListener("load", assign, { once: true })
    }
  }

  startAutoSlide() {
    if (this.slideTargets.length <= 1) return

    this.timer = setInterval(() => {
      this.showNextSlide()
    }, this.intervalValue)
  }

  stopAutoSlide() {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
  }

  showNextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slideTargets.length

    this.slideTargets[this.currentIndex].classList.remove("is-active")
    this.slideTargets[nextIndex].classList.add("is-active")

    this.currentIndex = nextIndex
  }
}